import { useMediaQuery } from "@mui/material";
import { useCallback, useState } from "react";

export const useHomePage = () => {
  const isLargeScreen = useMediaQuery("(min-width:1000px)");

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);

  const handleOpen = useCallback(() => {
    setEditMode(false);
    setCurrentProduct(null);
    setOpen(true);
  }, []);

  const handleEditOpen = useCallback((product) => {
    setEditMode(true);
    setCurrentProduct(product);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    isLargeScreen,
    open,
    editMode,
    currentProduct,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
  };
};
